/*eslint-env jquery*/
import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { classService } from '../../_services/class.service'
import moment from 'moment-jalaali' // Notice here !
import NumberFormat from 'react-number-format'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

function formatTimeValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e, 'YYYY-MM-DD HH:mm')
    if (momentValue.isValid()) {
      return momentValue.format('HH:mm')
    }
  }
}

class ClassSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      unionId: undefined
    }
  }

  // componentDidMount() {

  // }

  // componentWillMount() {
  //   this.getData();
  // }

  componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.defaultValue === undefined) {
      this.setState({ selected: '' })
      this.props.onChange('')
    }
    if (
      nextProps &&
      nextProps.unionId &&
      nextProps.unionId !== this.state.unionId
    ) {
      this.setState({ unionId: nextProps.unionId, selected: '' }, () => {
        this.getData()
      })
    }
  }

  getData() {
    classService.getByUnionId(this.state.unionId).then(res => {
      // console.log(res.data)
      let data = res.data
      this.setState({ data: data, loading: false, isSubmitting: false })
    })
  }

  handleChange = e => {
    this.props.onChange(e.value)
  }

  onClick = index => {
    const { data } = this.state
    var selected = data[index]
    this.setState({ selected: selected })
    this.props.onChange(selected.id, selected.amount)
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: provided => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f3f6ff',
        borderRadius: 10,
        height: 45,
        boxShadow: 'none',
        paddingRight: '12',
        border: 'none'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      })
    }
    const { loading, data, selected } = this.state
    const { disabled, required } = this.props

    return (
      <div>
        {loading ? (
          <div className="text-input classSelectLoading">
            <div className="text-input-indicator">
              <div className="load">
                <div id="wrapperr">
                  <p>در حال بارگذاری ...</p>
                  <div id="loader" />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className={
              disabled
                ? 'text-input classSelect disabled'
                : 'text-input classSelect'
            }>
            <span>
              {selected &&
                selected.lesson.name +
                  '    (' +
                  formatDefaultValue(selected.startDateTime) +
                  ')'}
            </span>
            <div className="arrow">
              <div aria-hidden="true" class="indicatorContainer">
                <svg
                  height="20"
                  width="20"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                  focusable="false">
                  <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
                </svg>
              </div>
            </div>
            <div className="list" id="classList">
              <table className="table text-center table-hover">
                <thead>
                  <th className="text-center">عنوان کلاس</th>
                  <th className="text-center">تاریخ کلاس</th>
                  <th className="text-center">ساعت شروع</th>
                  <th className="text-center">ساعت پایان</th>
                  <th className="text-center">هزینه کلاس</th>
                  <th className="text-center">ظرفیت باقیمانده</th>
                  <th className="text-center" />
                </thead>
                {data.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      selected && selected.id === item.id ? 'selected' : ''
                    }>
                    <td>{item.lesson.name}</td>
                    <td>{formatDefaultValue(item.startDateTime)}</td>
                    <td>{formatTimeValue(item.startDateTime)}</td>
                    <td>{formatTimeValue(item.endDateTime)}</td>
                    <td>
                      <NumberFormat
                        thousandSeparator={true}
                        className="numberFa"
                        value={item.amount}
                        displayType="text"
                        suffix=" ریال"
                      />
                    </td>
                    <td>{item.remainingCount}</td>
                    <td>
                      <button onClick={() => this.onClick(index)}>
                        انتخاب
                      </button>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        )}
      </div>
    )
  }
}
$(function() {
  // window.addEventListener('contextmenu', function (e) {e.preventDefault();});
  $(document).on('click', '.classSelect', function(e) {
    // console.log(e);
    // e.stopPropagation();
    // e.preventDefault();
    $('.classSelect').removeClass('currentClicked')
    $(this).toggleClass('active')
    return false
  })
  $(document).on('click', 'body ', function(e) {
    // console.log(e);

    // e.stopPropagation();
    $(this)
      .find('.classSelect')
      .removeClass('active')
  })
})
export default ClassSelect
